import {
  Text,
  useTranslate,
  useZustandModalKitStore,
  zustandModalKitSelector,
  EModalTypes,
} from 'react-gldn-kit';
import { useGetVipProgress } from 'react-render-hooks';

import { useHookFabric } from 'hooks/useHookFabric';

import styles from './LevelInfo.module.css';

const LevelInfo = () => {
  const { getText } = useTranslate('', '');

  const setModal = useZustandModalKitStore(
    zustandModalKitSelector.setModalInfoAction
  );

  const { percent, level } = useHookFabric<any>({
    fn: useGetVipProgress,
    customProps: {},
  });

  const handleOpenModal = () => {
    setModal(EModalTypes.AccrualHistory);
  };

  return (
    <div className={styles.wrapperLevelInfo}>
      <div className={styles.levelWrapper}>
        <div className={styles.yourLevel}>
          <Text idT="bonusCabinet.yourLevel" />
        </div>
        <div className={styles.stickerLevel}>
          <Text idT={`vipClub.level.${level.current}`} />
        </div>
      </div>

      <div className={styles.levelWidget}>
        <div className={styles.left}>
          <div className={styles.head}>
            <Text idT="bonusCabinet.vipProgress" />
          </div>
          <div className={styles.nextLevel}>
            <Text
              idT="newBonuses.progress.right"
              specValue={`${getText(`vipClub.level.${level.next}`)}`}
            />
          </div>
        </div>
        <div
          className={styles.right}
          style={{
            background: `radial-gradient(closest-side,var(--bonus-cabinet-level-info-progress-first-color) 90%, transparent 80% 100%),conic-gradient(rgb(var(--primary)) ${percent}%, var(--bonus-cabinet-level-info-progress-line-background) 0)`,
          }}
        >
          {percent}%
        </div>
      </div>

      {/* <div className={styles.row} onClick={handleOpenModal}>
        <div className={styles.accrualHistoryWrapper}>
          <HistorySvg />

          <div className={styles.accrualHistory}>
            <Text idT="bonusCabinet.accrualHistory" />
          </div>
        </div>

        <ArrowSvg width={16} height={9} classes={styles.rotate} />
      </div> */}
    </div>
  );
};

export default LevelInfo;
